/**
 * <SlotChangePendingDetail> — une demande « Modifier mes créneaux » qui attend son issue, en lecture seule
 * (molecule) : le cours qui change et le jour où il s'arrête, les horaires proposés, et où elle en est
 * (« Camille n'a pas encore répondu. »). Toutes les phrases viennent du serveur.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Badge } from "../../atoms/Badge"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Icon } from "../../atoms/icons/Icon"
import { Text } from "../../atoms/typography/Text"
import { type UISlotChangePending } from "../../../ports/primary/ui/types"
import { capitalizeFirst, joinFrench } from "../../../ports/primary/ui/formatters/textFormatter"

export type SlotChangePendingDetailProps = {
    pending: UISlotChangePending
    testID?: string
}

export function SlotChangePendingDetail(props: SlotChangePendingDetailProps) {
    const { pending, testID } = props

    return (
        <Stack gap="3" testID={testID}>
            <Row>
                <Badge text="Demande en cours" variant="warning" iconName="hourglass-half" />
            </Row>
            {pending.courses.map((course) => (
                <Stack key={course.label} gap="1">
                    <Text size="text-md" weight="bold">
                        {capitalizeFirst(course.label)}
                    </Text>
                    {course.stopsOnLabel != null && (
                        <Text size="text-sm" color="text-muted">
                            {`S'arrête à partir du ${course.stopsOnLabel}`}
                        </Text>
                    )}
                </Stack>
            ))}
            {pending.proposed.length > 0 && (
                <Text size="text-sm">
                    <Text size="text-sm" weight="bold">
                        {pending.proposed.length > 1 ? "Horaires proposés : " : "Horaire proposé : "}
                    </Text>
                    {joinFrench(pending.proposed)}
                </Text>
            )}
            <Row gap="2" align="center">
                <Icon name="hourglass-half" size={16} color="text-muted" />
                <Text size="text-sm" color="text-muted" style={styles.shrink}>
                    {pending.statusLine}
                </Text>
            </Row>
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    shrink: { flexShrink: 1 },
}))
